import script from "./DevolucionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DevolucionDetail.vue?vue&type=script&setup=true&lang=js"

import "./DevolucionDetail.vue?vue&type=style&index=0&id=389e1b29&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389e1b29"]])

export default __exports__